import useBusinessPostApi from './useBusinessPostApi.js';
import { useState } from 'react';
import { setFormSubmissionDetailsQuery } from './Queries';

export default function useSaveFormSubmission(submissionId, onSave) {
    const { save, isSaving } = useBusinessPostApi(
        `/submissions/${submissionId}`,
    );
    const [newAnswers, setNewAnswers] = useState({});

    function doSave() {
        save({
            answers: newAnswers,
        }).then(result => {
            onSave();
            setFormSubmissionDetailsQuery(submissionId, result);
        });
    }

    return {
        doSave,
        isSaving,
        newAnswers,
        setNewAnswers,
    };
}
